import './Moderator.scss';

import { useEffect, useState } from 'react';
import { FaArchive } from 'react-icons/fa';
import styled from 'styled-components';

import DeleteModal from '../../components/DeleteModal/DeleteModal';
import SideBar from '../../components/SideBar/SideBar';
import TableColumn from '../../components/TableColumn/TableColumn';
import TopNav from '../../components/TopNav/TopNav';
import api from '../../services/api';
import { useNavigate } from 'react-router-dom';
import { MdOutlineRemoveRedEye, MdOutlineSpeakerNotes } from 'react-icons/md';

function formatLastActive(value) {
    if (!value) return 'Never';
    const date = new Date(value);
    if (isNaN(date.getTime())) return '—';
    const diffDays = Math.floor((Date.now() - date.getTime()) / (1000 * 60 * 60 * 24));
    if (diffDays <= 0) return 'Today';
    if (diffDays === 1) return 'Yesterday';
    if (diffDays < 7) return `${diffDays}d ago`;
    if (diffDays < 30) return `${Math.floor(diffDays / 7)}w ago`;
    if (diffDays < 365) return `${Math.floor(diffDays / 30)}mo ago`;
    return `${Math.floor(diffDays / 365)}y ago`;
}

function lastActiveColor(value) {
    if (!value) return 'rgba(255, 255, 255, 0.35)';
    const diffDays = Math.floor((Date.now() - new Date(value).getTime()) / (1000 * 60 * 60 * 24));
    if (diffDays < 7) return '#2ECC71';
    if (diffDays < 30) return '#F1C40F';
    return '#E74C3C';
}


// const TabsContainer = styled.div`
//   display: flex;
//   justify-content: space-between;
//   gap: 16px;
// `;

// const Tab = styled.div`
//   align-items: center;
//   color: #fff;
//   display: flex;
//   justify-content: center;
//   padding: 1vw 0;
//   text-decoration: none;
//   width: 50%;
//   border-bottom: ${props => props.active ? '1px solid #a729f5' : 'none'};
//   user-select: none;
//   cursor: pointer;

//   > p  {
//     font-size: 14px;

//   }
// `;

function Moderators() {
    const navigate = useNavigate();

    const [mods, setMods] = useState([]);
    const [displayMods, setDisplayMods] = useState(mods);

    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(
        Number(localStorage.getItem("ListCurrentPageModerators")) || 1
    );
    const records = 10;


    const [activeSearch, setActiveSearch] = useState(false);
    const [filderedMods, setFilteredMods] = useState([]);
    const [deleteModal, setDeleteModal] = useState(false);
    const [modToDelete, setModToDelete] = useState("");


    function handleDelete(id) {
        console.log("this is the id: ", id);
        const deleteMod = async () => {
            try {
                await api.delete(`/admin-users/${id}`);
                alert("Successfully deleted.");
                window.location.reload();
            } catch (error) {
                alert("could not delete.");
                setDeleteModal(false);
            }
        };
        deleteMod();
    }

    async function handleApproveModerator(id) {
        try {
            // Default to "all" permissions for inline approve. The drill-in
            // page (/venue-requests/view/:id) lets you tune permissions if
            // needed; this button is the fast path for "yes, give them
            // everything". Mirrors what the existing AcceptVenueRequest
            // submits.
            await api.put(`/venue-requests/accept/${id}`, { permissions: ['all'] });
            window.location.reload();
        } catch (err) {
            console.error('Failed to approve:', err);
            alert('Could not approve. Try again or use the eye icon.');
        }
    }

    async function handleRevokeModerator(id) {
        if (!window.confirm("Revoke this moderator? They lose access to this venue (panel + SMS notifications). If it's their last venue, they lose Business panel access entirely. Their ZONA app account isn't affected, and they can request access again.")) return;
        try {
            await api.put(`/venue-requests/deny/${id}`, {});
            window.location.reload();
        } catch (err) {
            console.error('Failed to revoke:', err);
            alert('Could not revoke. Try again.');
        }
    }

    async function handlePendModerator(id) {
        if (!window.confirm('Move this request back to Pending? If it had been accepted, the venue access will be removed and the request will reappear at the top of the queue for re-decision. No email is sent.')) return;
        try {
            await api.put(`/venue-requests/pend/${id}`);
            window.location.reload();
        } catch (err) {
            console.error('Failed to pend:', err);
            alert('Could not move to pending. Try again.');
        }
    }

    async function handleArchiveModerator(id) {
        if (!window.confirm('Archive this moderator record? Hides from this list, but the record stays in the DB so you can restore it later.')) return;
        try {
            await api.put(`/venue-requests/archive/${id}`);
            window.location.reload();
        } catch (err) {
            console.error('Failed to archive:', err);
            alert('Could not archive. Try again.');
        }
    }

    async function handleUnarchiveModerator(id) {
        try {
            await api.put(`/venue-requests/unarchive/${id}`);
            window.location.reload();
        } catch (err) {
            console.error('Failed to unarchive:', err);
            alert('Could not unarchive. Try again.');
        }
    }

    const [sortBy, setSortBy] = useState(null);
    const [sortDirection, setSortDirection] = useState("null");
    const [showArchived, setShowArchived] = useState(false);
    const [archivedCount, setArchivedCount] = useState(0);
    const [statusFilter, setStatusFilter] = useState('pending'); // 'pending' | 'accepted' | 'denied'

    useEffect(() => {
        const getMods = async (page) => {
            try {
                const response = await api.get(`/venue-requests`, {
                    params: {
                        page: page,
                        records: records,
                        sort_column: sortBy,
                        sort: sortDirection,
                        archived_only: showArchived ? 'true' : undefined,
                        // In the Archived view show all archived regardless of
                        // status; otherwise filter by the selected status pill.
                        status: (!showArchived && statusFilter !== 'all') ? statusFilter : undefined,
                        // Archived items are reachable only via the dedicated
                        // archived link (archived_only=true). The main list,
                        // including the "All" status filter, hides them per
                        // the backend default (archived: { $ne: true }).
                    },
                });
                setArchivedCount(response.data.archived_count || 0);

                // Self-heal: a page number persisted from a larger filter (e.g.
                // page 2 of "All") can land on an empty page of a smaller
                // result set (e.g. Pending has only 1 page). Snap back to page
                // 1 instead of showing a misleading empty list.
                if ((response.data.data?.length || 0) === 0 && (response.data.total || 0) > 0 && page > 1) {
                    setCurrentPage(1);
                    localStorage.setItem("ListCurrentPageModerators", 1);
                    return;
                }

                const itensTableColumns = response.data.data.map((mod) => ({
                    Venue: mod.comments ? (
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                            {mod.name}
                            <span title={`Note: ${mod.comments}`} style={{ display: 'inline-flex', color: '#A89AFF' }}>
                                <MdOutlineSpeakerNotes size={14} />
                            </span>
                        </span>
                    ) : mod.name,
                    Name: mod.contact_name || mod.name,
                    Email: mod.contact_email || mod.email,
                    "Phone Number": mod.contact_country_calling_code ? `${mod.contact_country_calling_code}${mod.contact_phone}` : mod.phone,
                    "Last Sign In": (
                        <span style={{ color: lastActiveColor(mod.user_last_active), fontWeight: 500 }}>
                            {formatLastActive(mod.user_last_active)}
                        </span>
                    ),
                    Status: mod.status,
                    _id: mod._id,
                    'View': (
                        <button
                            title="View details"
                            style={{
                                background: 'rgba(79, 48, 234, 0.15)',
                                border: '1px solid rgba(79, 48, 234, 0.3)',
                                borderRadius: 6, padding: '6px 10px', cursor: 'pointer',
                                color: '#9580FF',
                                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                            }}
                            onClick={() => navigate(`/venue-requests/view/${mod._id}`)}
                        >
                            <MdOutlineRemoveRedEye size={16} />
                        </button>
                    ),
                    'Actions': (
                        <select
                            defaultValue=""
                            onChange={(e) => {
                                const action = e.target.value;
                                if (action === 'accept') handleApproveModerator(mod._id);
                                else if (action === 'deny') handleRevokeModerator(mod._id);
                                else if (action === 'pend') handlePendModerator(mod._id);
                                else if (action === 'archive') handleArchiveModerator(mod._id);
                                else if (action === 'unarchive') handleUnarchiveModerator(mod._id);
                                e.target.value = '';
                            }}
                            style={{
                                background: 'rgba(255, 255, 255, 0.06)',
                                color: '#fff',
                                border: '1px solid rgba(255, 255, 255, 0.15)',
                                borderRadius: 6,
                                padding: '6px 10px',
                                fontSize: 12,
                                fontWeight: 500,
                                cursor: 'pointer',
                                outline: 'none',
                            }}
                        >
                            <option value="" disabled style={{ color: '#000' }}>Action ▾</option>
                            {!showArchived && mod.status !== 'accepted' && <option value="accept" style={{ color: '#000' }}>Accept</option>}
                            {!showArchived && mod.status !== 'denied' && <option value="deny" style={{ color: '#000' }}>Deny</option>}
                            {!showArchived && mod.status !== 'pending' && <option value="pend" style={{ color: '#000' }}>Pending</option>}
                            {!showArchived && <option value="archive" style={{ color: '#000' }}>Archive</option>}
                            {showArchived && <option value="unarchive" style={{ color: '#000' }}>Unarchive</option>}
                        </select>
                    ),
                }));

                setMods(itensTableColumns);
                setTotalPages(response.data.total)

            } catch (error) {
                console.log(`Couldn't get moderators. This is the error: ${error}`);
            }
        };
        getMods(currentPage);
    }, [navigate, currentPage, sortBy, sortDirection, showArchived, statusFilter]);

    useEffect(() => {
        activeSearch ? setDisplayMods(filderedMods) : setDisplayMods(mods);
    }, [activeSearch, filderedMods, mods]);

    const columns = ["View", "Venue", "Name", "Email", "Phone Number", "Last Sign In", "Status", "Actions"];

    const sortableColumns = ["Name", "Status"];

    const getStatusColor = (status) => {
        console.log(status)
        const capitalizedStatus = status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
        switch (capitalizedStatus) {
            case 'Denied':
                return 'rgba(231, 76, 60, 0.1)';
            case 'Approved':
                return 'rgba(46, 204, 113, 0.1)';
            case 'Claiming':
                return 'rgba(441, 196, 15, 0.1)';
            case 'Pending':
                return 'rgba(231, 76, 60, 0.1)';
            case 'Accepted':
                return 'rgba(46, 204, 113, 0.1)';
            case 'Unlinked':
                return 'rgba(241, 196, 15, 0.1)';
            default:
                return 'inherit';
        }
    };


    const fetchAllData = async () => {
        try {
            const response = await api.get(`/venue-requests`, {
                params: {
                    records: 9999999999,
                },
            });

            console.log(response)

            return response.data.data.map((mod) => ({
                Venue: mod.name,
                Name: mod.contact_name || mod.name,
                Email: mod.contact_email || mod.email,
                "Phone Number": mod.phone,
                "Last Sign In": formatLastActive(mod.user_last_active),
                Status: mod.status,
                _id: mod._id,
            }));
        } catch (error) {
            console.log(`Error fetching all data: ${error}`);
            return [];
        }
    };


    const handlePageChange = (page) => {
        setCurrentPage(page);
        localStorage.setItem("ListCurrentPageModerators", page);
    };

    useEffect(() => {
        const storedPage = localStorage.getItem("ListCurrentPageModerators");
        setCurrentPage(Number(storedPage) || 1);
    }, []);


    const sortColumnsMapping = {
        Name: 'contact_name',
        Status: 'status',
    };

    const handleSort = (columnName) => {
        const backendColumnName = sortColumnsMapping[columnName];
        if (sortBy === backendColumnName) {
            setSortDirection(sortDirection === "asc" ? "desc" : "asc");
        } else {
            setSortBy(backendColumnName);
            setSortDirection("asc");
        }
    };
    


    const pillStyle = (active) => ({
        background: active ? '#4F30EA' : 'transparent',
        color: active ? '#fff' : 'rgba(255,255,255,0.7)',
        border: '1px solid ' + (active ? '#4F30EA' : 'rgba(255,255,255,0.15)'),
        borderRadius: 999,
        padding: '6px 14px',
        fontSize: 13,
        fontWeight: 500,
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
    });

    const renderModerators = (
        <>
            {/* Filter pills: status (Pending/Accepted/Denied) plus Archived,
                which replaces the old WhatsApp-style archived row. */}
            <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
                {[
                    { key: 'pending', label: 'Pending' },
                    { key: 'accepted', label: 'Accepted' },
                    { key: 'denied', label: 'Denied' },
                ].map(({ key, label }) => (
                    <button
                        key={key}
                        onClick={() => { setShowArchived(false); setStatusFilter(key); setCurrentPage(1); }}
                        style={pillStyle(!showArchived && statusFilter === key)}
                    >
                        {label}
                    </button>
                ))}
                <button
                    onClick={() => { setShowArchived(true); setCurrentPage(1); }}
                    style={pillStyle(showArchived)}
                >
                    <FaArchive size={12} style={{ marginRight: 6 }} />
                    Archived{archivedCount ? ` (${archivedCount})` : ''}
                </button>
            </div>
            <TableColumn
                title={showArchived ? 'Archived Venue Owners' : 'Venue Owners'}
                columns={columns}
                data={mods}
                sortableColumns={sortableColumns}
                hasExport={true}
                hasSearch={false}
                getStatusColor={getStatusColor}
                hasHeader={true}
                totalPages={totalPages}
                currentPage={currentPage}
                fetchAllData={fetchAllData}
                onPageChange={handlePageChange}
                onSort={handleSort}
            />
        </>
    )



    return (
        <main>
            <TopNav />
            <div className="main-container">
                <SideBar />
                {deleteModal && (
                    <DeleteModal
                        handleDelete={handleDelete}
                        setDeleteModal={setDeleteModal}
                        modToDelete={modToDelete}
                        tableName={"MODERATORS"}
                    />
                )}
                <article className="page-content">
                    
                <section className="moderators">
                    <h1 style={{ fontSize: 28, fontWeight: 700, color: '#fff', margin: '0 0 20px 0' }}>Permissions</h1>
                    {renderModerators}
                </section>
                    

                </article>
            </div>
        </main>
    );
}

export default Moderators;
